import React, { useState } from "react";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";

import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

import ConfirmPopup from "./ConfirmPopup";

// Popup to show when deleting items permanently.
const PermanentDeletePopup = ({
  item,
  title,
  message,
  handleDelete,
  handleCancel,
  loadingForConfirm,
  itemsToDelete,
}) => {
  const [userTextOnDelete, setUserTextOnDelete] = useState("");
  const deleteConfirmText = "permanently delete";

  return (
    <ConfirmPopup
      configData={{
        popupTitle: `Delete ${item}`,
        popupMessage: (
          <Box>
            <Alert
              icon={<WarningAmberRoundedIcon color="error" fontSize="large" />}
              sx={{
                mt: 1,
                mb: 2,
                padding: "0 5px",
                backgroundColor: "#ffe6e6",
                display: "flex",
                alignItems: "center",
                textAlign: "left",
              }}
              variant="outlined"
              severity="error"
            >
              {title}
            </Alert>
            <Box sx={{ mb: 2 }}>{message}</Box>
            {itemsToDelete?.length > 0 && (
              <Box sx={{ mb: 2 }}>
                <ul style={{ listStyleType: "square" }}>
                  {itemsToDelete.map((itemToDelete, index) => (
                    <li key={index}>{itemToDelete}</li>
                  ))}
                </ul>
              </Box>
            )}
            <Box sx={{ mb: 1 }}>
              To confirm deletion, type <i style={{ color: "#595959" }}>permanently delete</i>.
            </Box>
            <Box>
              <TextField
                placeholder="permanently delete"
                variant="standard"
                value={userTextOnDelete}
                onChange={(e) => setUserTextOnDelete(e.target.value)}
              />
            </Box>
          </Box>
        ),
        handleCancel: handleCancel,
        handleClick: userTextOnDelete === deleteConfirmText ? handleDelete : () => {},
        loadingForConfirm: loadingForConfirm,
        disableSave: userTextOnDelete !== deleteConfirmText,
        maxWidth: "760px",
      }}
    />
  );
};

export default PermanentDeletePopup;
